<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    size="lg"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-row no-gutters>
        <!-- <b-col class="p-0">
          <label>Ordem</label>
          <b-form-input
            type="text"
            placeholder="Ordem"
            v-model="form.ordem"
            name="ordem"
          >
          </b-form-input>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('ordem')"
            v-if="form.errors.has('ordem')"
          ></b-form-feedback>
        </b-col> -->
        <b-col class="p-0">
          <label>Tipo Trecho</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.tp_trecho"
              :options="optionsLivTpTrecho"
              name="tp_trecho"
              plain
              stacked
              value-field="value"
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('tp_trecho')"
            v-if="form.errors.has('tp_trecho')"
          ></b-form-feedback>
        </b-col>
        <b-col class="p-0">
          <label>Valor</label>
          <currency-input
            class="form-control"
            v-model="form.valor"
            placeholder="valor"
            :auto-decimal-mode="true"
            :locale="getCurrency.locale"
            style="text-align: right"
            :currency="{ prefix: 'R$ ' }"
            :distraction-free="getCurrency"
          />
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('ordem')"
            v-if="form.errors.has('ordem')"
          ></b-form-feedback>
        </b-col>
        <b-col class="p-0">
          <label>Motivo</label>
          <multiselect
            v-model="paramMotivoselected"
            :options="optionsParamMotivo"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('parmot_id')"
            v-if="form.errors.has('parmot_id')"
          ></b-form-feedback>
        </b-col>
        <b-col class="p-0">
          <label>Custo</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.tp_custo"
              :options="optionsLivTpcusto"
              name="tp_custo"
              plain
              stacked
              value-field="value"
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('tp_custo')"
            v-if="form.errors.has('tp_custo')"
          ></b-form-feedback>
        </b-col>
        <!-- <b-col class="p-0">
          <label>Tipo</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.tp_trecho_custo"
              :options="optionsLivTpTrechoCusto"
              name="tp_trecho_custo"
              plain
              stacked
              value-field="value"
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('tp_trecho_custo')"
            v-if="form.errors.has('tp_trecho_custo')"
          ></b-form-feedback>
        </b-col> -->
      </b-row>
      <b-row no-gutters>
        <b-col class="p-0">
          <label>Modal</label>
          <multiselect
            v-model="modalSelected"
            :options="optionsModal"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('bmodal_id')"
            v-if="form.errors.has('bmodal_id')"
          ></b-form-feedback>
        </b-col>
        <b-col class="p-0">
          <label>Município Início</label>
          <multiselect
            v-model="municipioIniSelected"
            :options="optionsMunicipio"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('municipio_id_ini')"
            v-if="form.errors.has('municipio_id_ini')"
          ></b-form-feedback>
        </b-col>
        <b-col class="p-0">
          <label>Município Fim</label>
          <multiselect
            v-model="municipioFimSelected"
            :options="optionsMunicipio"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('municipio_id_fim')"
            v-if="form.errors.has('municipio_id_fim')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col class="p-0">
          <label>Fornecedor</label>
          <multiselect
            v-model="fornecedorSelected"
            :options-limit="300"
            :limit="2"
            :limit-text="limitText"
            :options="optionsFornecedor"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Fornecedor ( Digite para pesquisar )"
            tag-placeholder="Selecionar"
            select-label="Selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
            :searchable="true"
            :loading="isLoadingFor"
            @search-change="listaClientesFornecedor"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('pessoa_id_for')"
            v-if="form.errors.has('pessoa_id_for')"
          ></b-form-feedback>
        </b-col>
        <!-- <b-col class="p-0">
          <label>Status</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.status"
              :options="optionsLivStatus"
              name="status"
              plain
              stacked
              value-field="value"
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('status')"
            v-if="form.errors.has('status')"
          ></b-form-feedback>
        </b-col> -->
      </b-row>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import accounting from "accounting";
export default {
  components: {},
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isLoadingFor: false,
      isFullscreen: false,
      modalSelected: [],
      municipioIniSelected: [],
      municipioFimSelected: [],
      fornecedorSelected: [],
      optionsLivStatus: [],
      optionsLivTpcusto: [],
      optionsLivPrincipal: [],
      optionsLivTpTrecho: [],
      optionsParamMotivo: [],
      paramMotivoselected: [],
      optionsModal: [],
      optionsMunicipio: [],
      optionsFornecedor: [],
      optionsLivTpTrechoCusto: [],
      form: new Form({
        peduncatr_id: "",
        pedunicar_id: "",
        ordem: "",
        parmot_id: "",
        carga_id: "",
        tp_custo: "",
        tp_trecho: "",
        valor: "",
        bmodal_id: "",
        status: 1,
        principal: 1,
        tp_trecho_custo: "",
        municipio_id_ini: "",
        municipio_id_fim: "",
        pessoa_id_for: "",
        peuncatrcu_id: "",
        pedido_unidade_carga_tre_custo: {},
      }),
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    fornecedorSelected(obj) {
      this.form.pessoa_id_for = obj.value;
    },
    municipioIniSelected(obj) {
      this.form.municipio_id_ini = obj.value;
    },
    municipioFimSelected(obj) {
      this.form.municipio_id_fim = obj.value;
    },
    paramMotivoselected(obj) {
      this.form.parmot_id = obj.value;
    },
    modalSelected(obj) {
      this.form.bmodal_id = obj.value;
    },
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.peduncatr_id);
      }
    },
    onCreate(data, tipo) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Vincular Trecho";
      this.modal_botao = "Vincular Trecho";
      this.modal_acao = "i";
      this.modalSelected = [];
      this.municipioIniSelected = [];
      this.municipioFimSelected = [];
      this.paramMotivoselected = [];
      this.fornecedorSelected = [];
      this.form.reset();
      if (tipo == 2) {
        this.pedunicar_id = data.pedunicar_id;
        this.fornecedorSelected = {
          label: data.pessoa_id_for.descr,
          value: data.pessoa_id_for.value,
        };
        this.municipioIniSelected = {
          label: data.municipio_id_ini.descr + " - " + data.municipio_id_ini.cd,
          value: data.municipio_id_ini.value,
        };
        this.municipioFimSelected = {
          label: data.municipio_id_fim.descr + " - " + data.municipio_id_fim.cd,
          value: data.municipio_id_fim.value,
        };
        this.form.pedunicar_id = data.pedunicar_id;
        this.form.carga_id = data.carga_id;
      }
      if (tipo == 1) {
        this.form.pedunicar_id = data.pedunicarId;
        if(data.pedidoUnidadeCargaTrecho.length > 0){
        this.form.carga_id = data.pedidoUnidadeCargaTrecho[data.pedidoUnidadeCargaTrecho.length - 1].cargaId;
      }
      }      
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar Trecho";
      this.modal_botao = "Alterar Trecho";
      this.modal_acao = "u";
      this.modalSelected = [];
      this.municipioIniSelected = [];
      this.municipioFimSelected = [];
      this.fornecedorSelected = [];
      this.paramMotivoselected = [];
      this.form.reset();
      this.form.ordem = data.ordem;
      this.form.tp_custo = data.tpCusto.valor;
      this.form.tp_trecho = data.tpTrecho.valor;
      this.form.tp_trecho_custo = data.tpTrechoCusto.valor;
      this.modalSelected = {
        label: data.bModal.descr,
        value: data.bModal.bmodalId,
      };
      this.municipioIniSelected = {
        label: data.municipioIni.nome,
        value: data.municipioIni.municipio_id,
      };
      this.municipioFimSelected = {
        label: data.municipioFim.nome,
        value: data.municipioFim.municipio_id,
      };
      this.form.valor = parseFloat(
        data.PedidoUnidadeCargaTreCusto[0].vlrCusto
      );
      if (data.motivo != null) {
        this.paramMotivoselected = {
          label: data.motivo.descr,
          value: data.motivo.parmotId,
        };
      }
      if (data.fornecedor.pessoaJuridica !== null) {
        this.fornecedorSelected = {
          label:
            data.fornecedor.cd +
            " - " +
            data.fornecedor.pessoaJuridica.razaoSocial +
            " - " +
            this.onFormataCnpj(
              data.fornecedor.pessoaJuridica.cnpjBase,
              data.fornecedor.pessoaJuridica.cnpjFilial,
              data.fornecedor.pessoaJuridica.cnpjDigito
            ) +
            " - " +
            data.fornecedor.pessoaJuridica.inscricaoEstadual,
          value: data.fornecedor.pessoaJuridica.pessoaId,
        };
      }
      if (data.fornecedor.pessoaFisica !== null) {
        this.fornecedorSelected = {
          label:
            data.fornecedor.cd +
            " - " +
            data.fornecedor.pessoaFisica.nome +
            " - " +
            data.fornecedor.pessoaFisica.cpf,
          value: data.fornecedor.pessoaFisica.pessoaId,
        };
      }
      if (data.fornecedor.pessoaExterior !== null) {
        this.fornecedorSelected = {
          label:
            data.fornecedor.cd +
            " - " +
            data.fornecedor.pessoaExterior.nome +
            " - " +
            data.fornecedor.pessoaExterior.cuit,
          value: data.fornecedor.pessoaExterior.pessoaId,
        };
      }
      this.form.pedunicar_id = data.pedunicarId;
      this.form.peduncatr_id = data.peduncatrId;
      this.form.peuncatrcu_id = data.PedidoUnidadeCargaTreCusto[0].peuncatrcuId;
      this.form.carga_id = data.cargaId;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.status = 1;
      this.form.principal = 1;
      this.form.ordem = 1;
      this.form.tp_trecho_custo = 1;
      this.form
        .patch("/api/gestaocarga/trecho/store/" + this.form.pedunicar_id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          } else {
            Event.$emit("reloadVuetable");
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.status = 1;
      this.form.principal = 1;
      this.form.ordem = 1;
      this.form.tp_trecho_custo = 1;
      this.form.pedido_unidade_carga_tre_custo = {
        vlr_custo: this.form.valor,
        peuncatrcu_id: this.form.peuncatrcu_id,
      };
      this.form
        .patch("/api/gestaocarga/trecho/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          } else {
            Event.$emit("reloadVuetable");
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onCalcular(data) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch(
          "/api/gerenciamentotransporte/trecho/calculo/" + data.peduncatr_id
        )
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          } else {
            Event.$emit("reloadVuetable");
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/gestaocarga/jsonlistgeraltrecho")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.optionsLivStatus.push({ text: obj.descr, value: obj.valor });
          });
          response.tp_custo.forEach((obj) => {
            this.optionsLivTpcusto.push({ text: obj.descr, value: obj.valor });
          });
          response.tp_trecho.forEach((obj) => {
            this.optionsLivTpTrecho.push({ text: obj.descr, value: obj.valor });
          });
          response.principal.forEach((obj) => {
            this.optionsLivPrincipal.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_trecho_custo.forEach((obj) => {
            this.optionsLivTpTrechoCusto.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.param_motivo.forEach((obj) => {
            this.optionsParamMotivo.push({
              label: obj.descr,
              value: obj.parmot_id,
            });
          });
          response.municipio.forEach((obj) => {
            this.optionsMunicipio.push({
              label: obj.nome,
              value: obj.municipio_id,
            });
          });
          response.modal.forEach((obj) => {
            this.optionsModal.push({ label: obj.descr, value: obj.bmodal_id });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    listaClientesFornecedor(search) {
      if (search.length >= 3) {
        this.isLoadingFor = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist/fornecedor")
          .then((response) => {
            this.optionsFornecedor = [];
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj) => {
              this.optionsFornecedor.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
            });
            response.itemsF.forEach((obj) => {
              this.optionsFornecedor.push({
                label: obj.pessoa.cd + " - " + obj.nome + " - " + obj.cpf,
                value: obj.pessoa_id,
              });
            });
            response.itemsE.forEach((obj) => {
              this.optionsFornecedor.push({
                label: obj.pessoa.cd + " - " + obj.nome + " - " + obj.cuit,
                value: obj.pessoa_id,
              });
            });
            this.isLoadingFor = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
